<template>
  <div class="embed-layout">
    <div class="embed-layout__toolbar">
      <span class="embed-layout__title">BMS</span>
      <a
        href="javascript:;"
        class="embed-layout__task-btn"
        @click="openTaskManager"
      >
        <i class="el-icon-s-tools" /> 任务管理
      </a>
    </div>
    <div class="embed-layout__body">
      <router-view />
    </div>
    <el-dialog
      title="导出/导入"
      :visible.sync="showTaskDialog"
      width="1400px"
      append-to-body
      custom-class="embed-task-dialog"
    >
      <exportListDetail v-if="showTaskDialog" />
    </el-dialog>
  </div>
</template>

<script>
import exportListDetail from '@/components/common/exportList.vue';

/**
 * 外部系统 iframe 嵌入专用布局：无 BMS 顶栏/侧栏，保留任务管理（异步导出/导入结果下载）。
 */
export default {
  name: 'EmbedLayout',
  components: {
    exportListDetail,
  },
  data() {
    return {
      showTaskDialog: false,
    };
  },
  methods: {
    /** 打开任务管理弹窗（导出/导入记录，与站内 Header 一致） */
    openTaskManager() {
      this.showTaskDialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
.embed-layout {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;
  box-sizing: border-box;
}
.embed-layout__toolbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 12px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
}
.embed-layout__title {
  font-size: 14px;
  color: #606266;
}
.embed-layout__task-btn {
  font-size: 13px;
  color: #005bf5;
  text-decoration: none;
  cursor: pointer;
  user-select: none;
}
.embed-layout__task-btn:hover {
  opacity: 0.85;
}
.embed-layout__body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 12px;
  box-sizing: border-box;
}
</style>
